import { buildScopedI18n } from '../../../../../utils/buildScopedI18n';
import configExcludedEsCL from './locales/es-CL.json';
import configExcludedEnUS from './locales/en-US.json';
import configExcludedPtBR from './locales/pt-BR.json';

export const configExcludedI18n = buildScopedI18n({
  esCL: configExcludedEsCL,
  enUS: configExcludedEnUS,
  ptBR: configExcludedPtBR,
});
